import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const PUT_BILLET_URL = (billetId) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/billett/${billetId}`;
